import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../../utils/Requests/axios";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import _ from "lodash";
import { Loader } from "../../Common";

const RecommendedAction = ({
  from,
  pass,
  value,
  contentQualityReport,
  setContentQualityReport,
  articalUuid,
  setForceCheckList,
  setForceCheckStatus,
}) => {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);

  const [isloading, setIsloading] = useState(false);
  const [articalId, setArticalId] = useState("");
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const forceCheckForNew = () => {
    setIsloading(true);
    const {
      article: { title, content },
      type,
    } = value;
    const { updateType, ...rest } = value;

    if (!title || !content || !type) {
      toast.error(t("Please fill in all the required fields"));
    } else {
      const payload = _.cloneDeep(rest);
      const url = `users/${userData?.uuid}/articles/tasks`;
      axiosInstance
        .post(url, payload)
        .then((response) => {
          setArticalId(response?.data?.uuid);
          setShouldUpdate(true);
        })
        .catch(() => {
          toast.error(t("There was an error fetching response"));
          setIsloading(false);
        });
    }
  };

  const forceCheckForDraft = () => {
    setIsloading(true);
    const {
      article: { title, content },
      type,
    } = value;
    const { updateType, ...rest } = value;

    if (!title || !content || !type) {
      toast.error(t("Please fill in all the required fields"));
    } else {
      const payload = _.cloneDeep(rest);
      const url = `users/${userData?.uuid}/articles/${articalUuid}/tasks`;
      axiosInstance
        .post(url, payload)
        .then((response) => {
          setArticalId(response?.data?.uuid);
          setShouldUpdate(true);
        })
        .catch(() => {
          toast.error(t("There was an error fetching response"));
          setIsloading(false);
        });
    }
  };

  useEffect(() => {
    if (shouldUpdate) {
      const timer = setTimeout(() => {
        userStatusVerify(articalId);
        setShouldUpdate(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line
  }, [shouldUpdate]);

  const extractArticleUUID = (resource) => {
    // eslint-disable-next-line
    const match = resource.match(/\/articles\/([a-f0-9\-]+)/i);
    return match ? match[1] : null;
  };

  const userStatusVerify = (task) => {
    const url = `users/${userData?.uuid}/tasks/${task}`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (response?.data?.status === "completed") {
          const articleUUID = extractArticleUUID(response?.data?.resource);
          userQualityUpdate(articleUUID);
          setIsloading(false);
        } else {
          setShouldUpdate(true);
        }
      })
      .catch(() => {
        toast.error(t("There was an error fetching response"));
      });
  };

  const userQualityUpdate = (uuid) => {
    const url = `users/${userData?.uuid}/articles/${uuid}/qualities/${value?.updateType}`;
    axiosInstance
      .get(url)
      .then((response) => {
        const hasPlagiarismIssue = response?.data?.checks?.some(
          (check) => check.type === 2 && !check.solved
        );
        const hasAIssue = response?.data?.checks?.some(
          (check) => check.type === 5 && !check.solved
        );

        const status = {
          ai: {
            passed: hasAIssue
              ? false
              : value?.updateType === 5 && response?.data?.checks?.length === 0
              ? true
              : contentQualityReport?.ai?.passed,
          },
          plagiarism: {
            passed: hasPlagiarismIssue
              ? false
              : value?.updateType === 2 && response?.data?.checks?.length === 0
              ? true
              : contentQualityReport?.plagiarism?.passed,
          },
        };
        setContentQualityReport((prevState) => {
          const prevChecks = Array.isArray(prevState.checks)
            ? prevState.checks
            : [];
          const newChecks = Array.isArray(response?.data?.checks)
            ? response.data.checks
            : [response.data.checks];

          const checksMap = new Map(
            prevChecks.map((check) => [check.type, check])
          );

          newChecks.forEach((check) => {
            if (check?.type) {
              checksMap.set(check.type, check);
            }
          });

          return {
            ...prevState,
            ...status,
            checks: Array.from(checksMap.values()),
          };
        });

        setForceCheckList(response?.data?.checks);
        setForceCheckStatus(status);
        setIsloading(false);
      })
      .catch(() => {
        toast.error(t("There was an error fetching response"));
      });
  };

  return (
    <div className="status-bar">
      <p style={{ color: "#6C747A" }}>{`${t("Recommended action")}`}:</p>
      <div className="mt-2 d-flex gap-3">
        {pass === null && (
          <>
            <button
              className={`btn btn-outline-primary btn-sm ${
                isloading && "none-click-button"
              }`}
              onClick={
                isloading
                  ? null
                  : from === "new"
                  ? forceCheckForNew
                  : forceCheckForDraft
              }
            >
              {isloading ? <Loader /> : t("Force Check")}
            </button>
          </>
        )}
        {pass !== null && (
          <>
            <button className="btn btn-outline-primary btn-sm">
              {`${t("Rewrite for 1 Credit")}`}
            </button>
            <button
              className={`btn btn-outline-primary btn-sm ${
                isloading && "none-click-button"
              }`}
              onClick={
                isloading
                  ? null
                  : from === "new"
                  ? forceCheckForNew
                  : forceCheckForDraft
              }
            >
              {isloading ? <Loader /> : t("Recheck")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RecommendedAction;
